export default "dist/images/block-column-basic.6369628.png";